<div class="flex justify-between p-card-title">
  <ng-content></ng-content>
  <div class="flex gap-1">
    <ng-content select="[toolbarButtons]"></ng-content>
    @if(showEdit) {
    <app-icon-button [icon]="icons.solid.faPenToSquare" (click)="editClicked()" textSize="text-lg"
      pTooltip="Edit" [showDelay]="300"></app-icon-button>
    }

    @if(showDataPad && allowDataPadButton) {
    <app-icon-button [icon]="icons.ppmSolid.dataPad"
      (click)="dataPadClicked()" textSize="text-lg" pTooltip="Show in DataPad" [showDelay]="300"></app-icon-button>
    }

    @if(showClose) {
    <app-icon-button  [icon]="icons.solid.faCircleXmark" (click)="closeClicked()"
      textSize="text-lg" pTooltip="Close DataPad" [showDelay]="300"></app-icon-button>
    }



  </div>
</div>